import moment from 'moment';

export const getTimeDifferenceInDays = (date: string, referenceDate: string = undefined): number =>
	moment(date).startOf('day').diff(moment(referenceDate).startOf('day'), 'days');
